<form
  class="tw-flex tw-h-full tw-flex-col tw-gap-4"
  [formGroup]="form"
  [appApiAction]="formPromise"
>
  <div class="tw-flex tw-flex-col tw-gap-4 tw-rounded-2xl tw-bg-glass-card tw-p-4">
    <div class="tw-flex tw-flex-col tw-gap-1">
      <span
        class="tw-font-montserrat tw-text-sm tw-font-semibold tw-leading-none tw-text-color-text-tertiary"
        >{{ "teamName" | i18n }} *</span
      >
      <input
        type="text"
        maxlength="50"
        formControlName="collectionName"
        [placeholder]="'teamNamePlaceholderExample' | i18n"
        [ngClass]="{
          '!tw-border-color-status-error':
            form.controls['collectionName'].invalid && form.controls['collectionName'].touched,
        }"
        class="tw-w-full tw-rounded-xl tw-border tw-border-transparent tw-bg-color-surface-input tw-px-4 tw-py-3 tw-font-montserrat tw-text-sm tw-font-medium tw-leading-none tw-text-color-text-default focus:tw-outline-none"
      />
      @if (form.controls["collectionName"].invalid && form.controls["collectionName"].touched) {
        <span class="tw-text-xs tw-text-dt-text-error">{{ "thisFieldIsRequired" | i18n }}</span>
      }
    </div>
    <p
      class="tw-m-0 tw-font-montserrat tw-text-[13px] tw-font-medium tw-leading-[145%] tw-text-color-text-tertiary"
    >
      {{ "createTeamHelperText" | i18n }}
    </p>
  </div>

  <app-gloss-button [options]="submitButtonOptions" class="tw-mt-auto"></app-gloss-button>
</form>
